import { render, staticRenderFns } from "./accompany.vue?vue&type=template&id=654b3c56"
import script from "./accompany.vue?vue&type=script&lang=js"
export * from "./accompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports